import styled from 'styled-components';
import AccountSettings from './AccountSettings';
import { colorSchema, media } from 'utils/style';

export default styled(AccountSettings)`
  .account-settings {
    display: grid;
    margin: 0 0.6rem;
    grid-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
    flex-direction: column;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(12, 1fr);
      grid-gap: 24px;
      margin: 0 auto;
    `}

    &__body {
      grid-column: 1 / span 4;
      grid-row: 1;
      margin-bottom: 4.8rem;

      ${media.greaterThan('tablet')`
        grid-column: 4 / span 6;
        margin: 0;
        padding: 3.2rem 0;
      `}
    }

    &__header {
      border-bottom: 1px solid ${colorSchema('grey200')};
      ${media.greaterThan('tablet')`
        padding-bottom: 1.6rem;
      `}
    }

    &__back {
      font-size: 1.6rem;
      font-weight: normal;
      padding: 0;

      svg {
        width: 0.6rem;
      }
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.4rem;
      font-weight: normal;
      line-height: 1.58;
      margin: 0;
    }

    &__input {
      height: 100%;
      margin-bottom: 1.6rem;
      min-width: 284px;

      input {
        height: 48px;
      }
    }

    &__field-container {
      align-items: flex-start;
      display: flex;
      flex-direction: column;

      ${media.greaterThan('tablet')`
        align-items: flex-end;
      `}
    }

    &__select {
      width: 284px;
    }

    &__radios {
      width: 284px;
    }

    &__password-container {
      padding-top: 2.4rem;
    }
  }
`;
